// import { userContext } from "Context/userContext";
import React, { useCallback } from "react";
// import { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
// import { getProvinsi } from "services/apiRoutes";

export default function Provinsi({ onChange,disabled,all }) {
  const [prov, setProv] = useState();

  const provAPI = useCallback(async () => {
    // const res = await getProvinsi();
    // const { data } = res.data;
    // setProv(data);
  }, []);

  useEffect(() => {
    provAPI();
  }, [provAPI]);

  return (
    <div className="flex flex-col">
      <label htmlFor="kabupaten" className="m-2 text-sm font-semibold">
        Provinsi
      </label>
      <select
        // defaultValue={defaultValue}
        // value={setValue}
        disabled={disabled}
        onChange={onChange}
        name="provinsi"
        className="px-3 py-3 mr-4 border seacrh rounded-2xl focus:ring-2 focus:ring-primary focus:border-none focus:outline-none"
      >
        {prov?.map((e, index) => (
          <>
            {index === 0 && (
              <option key="jdjd82738" value="null" disabled={!all}>
                Semua Provinsi
              </option>
            )}
            <option key={e.kodeProvinsi} value={e.kodeProvinsi}>
              {e.namaProvinsi}
            </option>
          </>
        ))}
      </select>
    </div>
  );
}
